import React from 'react';
import PersonSessions from 'containers/pages/persons/PersonSessions';

const PersonSessionsTab = () => {
  return <PersonSessions />;
};

export default PersonSessionsTab;
